export default {"id":"0d4a4e74","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}